import React from "react";
import { Briefcase, Folder, Target, Compass, AlertTriangle, PoundSterling, Cpu, Clock } from "lucide-react";

const Field = ({ icon: Icon, label, value, mono, testId }) => (
    <div data-testid={testId} className="flex flex-col gap-1.5 border-l border-slate-200 pl-4 py-1">
        <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
            <Icon className="h-3 w-3" />
            {label}
        </div>
        <div className={`text-[15px] text-slate-900 ${mono ? "font-mono" : ""}`}>
            {value}
        </div>
    </div>
);

const fmtGBP = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);

export const IntakeCard = ({ route }) => {
    if (!route) return null;
    return (
        <div data-testid="intake-card" className="border border-slate-200 bg-white rounded-sm hover-lift">
            <div className="px-8 pt-8 pb-2">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                    Submitted prompt route
                </div>
                <div className="mt-2 font-heading text-2xl font-semibold text-slate-900">
                    {route.prompt_purpose}
                </div>
            </div>
            <div className="px-8 pb-8 pt-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                <Field icon={Briefcase} label="Requesting team" value={route.requesting_team} testId="intake-team" />
                <Field icon={Folder} label="Project context" value={route.project_context} testId="intake-project" />
                <Field icon={Target} label="Intended decision support" value={route.intended_decision_support} testId="intake-decision" />
                <Field icon={Compass} label="Prompt purpose" value="Bounded summary + budget rationale draft" testId="intake-purpose" />
                <Field
                    icon={AlertTriangle}
                    label="Risk level"
                    value={
                        <span className="inline-flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
                            {route.risk_level}
                        </span>
                    }
                    testId="intake-risk"
                />
                <Field
                    icon={PoundSterling}
                    label="Estimated budget impact"
                    value={fmtGBP(route.estimated_budget_impact_gbp)}
                    mono
                    testId="intake-budget"
                />
                <Field icon={Cpu} label="Requested model route" value={route.requested_model_route} testId="intake-requested-model" />
                <Field icon={Clock} label="Submitted at" value={route.submitted_at} mono testId="intake-submitted" />
            </div>
        </div>
    );
};

export default IntakeCard;
